import { isFeatureSwitchOn } from '../utils/window';

// API ROUTES CONSTANTS
export const API = {
  GUEST_ORDER_DETAILS: '/customer/order/v1/guest/orderdetailsgroup',
  INSTORE_ORDER_DETAILS: '/customer/order/v1/guest/instore/orderdetailsgroup',
  AUTH_ORDER_DETAILS: '/customer/order/v1/orderdetailsgroup',
  CANCEL_ITEMS: '/customer/order/v1/cancelorder',
  CANCEL_REQUEST_ACTION: '/customer/order/v1/cancelrequest',
  RETURN_ELIGIBILITY: '/customer/returns/v1/ssrorderview',
  RETURN_HRTV: '/customer/returns/v1/ssrhrtvpolicyvalidator',
  RETURN_CREATE: '/customer/returns/v1/ssrreturncreate',
  SHIPMENT_TRACKING: '/customer/order/v1/trackingdetails',
  OMS_SHIPMENT_TRACKING: '/oms/customer/order/v1/trackingdetails',
  BODFS_SHIPMENT_TRACKING: '/customer/order/v1/trackyourtruck',
  SHIPMENT_TRACKING_LINEHAUL: '/customer/order/v1/linehaul/trackingdetails',
  AVAILABLE_DELIVERY_SLOTS: '/customer/order/v1/availabledeliveryslots',
  COM_APPLIANCE_DELIVERY_SLOTS: '/customer/order/v1/sourcing/availabledeliveryslots',
  APPLIANCE_RESCHEDULE: '/customer/order/v1/appliancereschedule',
  COM_APPLIANCE_RESCHEDULE: '/customer/order/v1/comappliancereschedule',
  MA_CANCEL_ELIGIBILITY: '/customer/order/v1/macanceleligibility',
  CUST_SERV_AGREEMENT: '/customer/order/v1/instoreCustServAgreement',
  MA_CANCEL_REQUEST: '/customer/order/v1/appliancecancelorder',
  ONLINE_ORDER_HISTORY: '/customer/order/v1/orderhistory',
  BAZAAR_VOICE_TOKEN: '/customer/order/v1/getreviewerinfo',
  ERECEIPTS_SUMMARY: '/customer/order/v1/ereceipts/summary',
  ERECEIPTS_DETAIL: '/customer/order/v1/ereceipts/detail'

};

// URL ROUTES CONSTANTS
export const URL = {
  [API.GUEST_ORDER_DETAILS]: '/order/view/tracking/onlineorder',
  [API.CANCEL_ITEMS]: '/order/view/tracking/onlineorder/cancelorder',
  [API.RETURN_ELIGIBILITY]: '/order/view/tracking/onlineorder/returns',
  GUEST_ORDER_DETAILS_V1: '/order/view/tracking/onlineorder',
  INSTORE_ORDER_DETAILS_V1: '/order/view/tracking/instoreorder',
  ORDER_HISTORY: '/order/view/summary',
  TERMS_CONDITIONS: 'https://www.homedepot.com/c/PH_MyAccount',
  PRIVACY_SECURITY: 'https://www.homedepot.com/c/Privacy_Security',
  APPLIANCE_RETURN: 'https://www.homedepot.com/c/Return_Policy',
  INSTALLATION_REQUIREMENTS:
    'https://www.homedepot.com/c/Appliance_Delivery_Installation',
  HOMEPAGE: '/',
  CANCELLATION_POLICY:
    'https://www.homedepot.com/c/Customer_Support_Answers#cancel'
};

// FOR BREADCRUMB USE
export const BREADCRUMB = {
  '/': 'Home',
  '/order': null,
  '/order/view': null,
  '/order/view/tracking': 'Track Your Order',
  '/order/view/tracking/onlineorder': 'Online Orders',
  '/order/view/tracking/onlineorder/cancel': 'Cancel Items',
  '/order/view/tracking/onlineorder/returns': 'Start a Return',
  '/order/view/tracking/onlineorder/macancel': 'Cancel Appliance',
  '/order/view/ereceipt': null,
  '/order/view/ereceipt/summary': 'In-Store e-Receipts',
  '/order/view/summary': 'Online Orders',
  '/order/view/summary/cancel': 'Cancel Items',
  '/order/view/summary/returns': 'Start a Return',
  '/order/view/tracking/instoreorder': 'In-Store Orders',
  '/order/view/instoresummary': 'In-Store Orders',
  '/order/view/instoresummary/details': 'Order Details',
  '/order/view/summary/macancel': 'Cancel Appliance',
  '/order/view/:undefined': 'Page Not Found',
  '/order/view/:undefined/:undefined': 'Page Not Found',
  '/order/view/myratingsandreviews': 'My Ratings & Reviews',
};

const AUTH_SIGNIN = '/auth/view/signin';
const AUTH_SIGNIN_SUMMARY = '/auth/view/signin?redirect=/order/view/summary';
const ACCOUNT_LOGON =
  '/account/view/logon/redirect/%252Forder%252Fview%252Fsummary';
// FOR ROUTING USE
export const PATH = {
  ACCOUNT_REGISTRATION: '/account/view/register',
  AUTH_SIGNIN: isFeatureSwitchOn('ENABLE_AUTH_SIGNIN')
    ? AUTH_SIGNIN
    : ACCOUNT_LOGON,
  AUTH_SIGNIN_SUMMARY: isFeatureSwitchOn('ENABLE_AUTH_SIGNIN')
    ? AUTH_SIGNIN_SUMMARY
    : ACCOUNT_LOGON,
  ACCOUNT_PROFILE: '/account/view/profile',
  MOBILE_ACCOUNT_PROFILE: '/account/view/mobile/menu',
  ORDER_TRACKING: '/order/view/tracking',
  ONLINE_ORDER: '/order/view/tracking/onlineorder',
  ONLINE_CANCEL: '/order/view/tracking/onlineorder/cancel',
  ONLINE_RETURNS: '/order/view/tracking/onlineorder/returns',
  ONLINE_RECEIPTS: '/order/view/tracking/onlineorder/receipt',
  ONLINE_AUTH_RECEIPTS: '/order/view/onlineorder/receipt',
  ERECEIPTS_SUMMARY: '/order/view/ereceipt/summary',
  ORDER_HISTORY: '/order/view/summary',
  ORDER_HISTORY_CANCEL: '/order/view/summary/cancel',
  ORDER_HISTORY_RETURNS: '/order/view/summary/returns',
  IN_STORE_ORDER: '/order/view/tracking/instoreorder',
  AUTH_IN_STORE_TRACKING: '/order/view/instoresummary',
  AUTH_IN_STORE_ORDER: '/order/view/instoresummary/details',
  GUEST_MA_CANCELLATION: '/order/view/tracking/onlineorder/macancel',
  AUTH_MA_CANCELLATION: '/order/view/summary/macancel',
  RATINGS_REVIEWS: '/order/view/myratingsandreviews',
};

